import apiWorker from '../apiWorker'

const contactPurchases = {
    create : (data) => apiWorker('post', `/v1/billing/contact_purchases`, data, true),
}

export default contactPurchases;